/**
 * @file automatically generated from MApp.Data.DataFieldType
 */

export enum DataFieldType {
    Boolean = 0,
    String = 1,
    Double = 2,
    Float = 3,
    SInt32 = 4,
    UInt32 = 5,
    SInt64 = 6,
    UInt64 = 7,
    Bytes = 8,
    DateTime = 9,
    Guid = 10
}
